export { default as Footer } from "./Footer";
export { FooterLegal } from "./FooterLegal";
